export default __webpack_public_path__ + "static/penetration_testing-02ac0635db5bd356890f14641483e2b1.png";